// extracted by mini-css-extract-plugin
export default {"productSection":"ProductsPage_productSection__LS129","productTitle":"ProductsPage_productTitle__tEgEg","underline":"ProductsPage_underline__80Sei"};